import React, {useContext, useState} from "react";

import {View, Text, BackHandler}  from 'react-native'

import {useNavigation} from '@react-navigation/native'

import contexto from '../util/contexto'

import ItemCard from '../componentes/ItemCard'

import {carregamento} from '../componentes/Carregamento'

import {semDados} from '../componentes/SemDados'

import {ViewDegradeVertical} from '../componentes/ViewDegradeVertical';

import {estilos} from '../util/estilos'

import { useFocusEffect } from '@react-navigation/native';

import cores from '../util/cores'

import * as data from '../util/data'

import * as util from '../util/util'

import Botao from '../componentes/Botao'

import * as numeros from '../util/numeros'

import {ITEM_TIPO_PRODUTO, PRIVILEGIO_GESTOR, PRIVILEGIO_ADMIN, TELA_PRINCIPAL, TELA_FINANCEIRA} from '../util/constantes'

import {TELA_LOGIN, TELA_MEUS_ITENS, TELA_DETALHE_USUARIO, TELA_ANUNCIO, 
	TELA_MEUS_PEDIDOS, TELA_DETALHE_PEDIDO, TELA_MINHAS_PROPOSTAS,
	TELA_CATEGORIA, TELA_SUBCATEGORIA, TELA_BUSCAR_PEDIDOS, TELA_BUSCAR_ITENS,
	TELA_MEUS_ENDERECOS, TELA_DENUNCIAS} from '../util/constantes'

import Bloco from '../componentes/Bloco'

import Imagem from '../componentes/Imagem'

import {buscarPedidosDisponiveis as wsBuscarPedidosDisponiveis} from '../ws/ws_pedidos'

import {buscarOfertas as wsBuscarOfertas} from '../ws/ws_itens'

import Scroll from '../componentes/Scroll'




export default function TelaPrincipal(props){

    const navegacao = new useNavigation();

	const {valorContexto, setValorContexto} = useContext(contexto);

	const [sincronizandoPedidos, setSincronizandoPedidos] = useState(false)  

	const [sincronizandoOfertas, setSincronizandoOfertas] = useState(false)  

	const [listaPedidos, setListaPedidos] = useState([])
	
	const [listaOfertasProtutos, setListaOfertasProtutos] = useState([])
	
	const [listaOfertasServicos, setListaOfertasServicos] = useState([])

	
	
	useFocusEffect(React.useCallback(() => {
		
		const backAction = () => {
		
			BackHandler.exitApp();
	
			return true;
		};
		
		BackHandler.addEventListener('hardwareBackPress', backAction);
				
		prepararTela()
				
		return () => {
			BackHandler.removeEventListener('hardwareBackPress', backAction);
		};
	}, []));
	
	
	const prepararTela= async ()=>{
		
		util.print("TelaPrincipal");

		buscarPedidosDisponiveis();
		
		buscarOfertas();	
	};
	
	
	const buscarPedidosDisponiveis= async ()=>{
		
		console.log('TelaPrincipal - preparando pedidos disponiveis');

		setSincronizandoPedidos(true)

		let itens  = await wsBuscarPedidosDisponiveis(valorContexto.idUsuarioAtual);
		
		setListaPedidos(util.temConteudo(itens)?itens:[]);
	
		setSincronizandoPedidos(false)
	}


	const buscarOfertas= async ()=>{
		
		console.log('TelaPrincipal - preparando ofertas disponiveis');

		setSincronizandoOfertas(true)

		let itens  = await wsBuscarOfertas(valorContexto.idUsuarioAtual);
		
		if(util.temConteudo(itens)){
	
			let produtos = []
			let servicos = []
			
			itens.forEach((item)=>{
				
				if(item.tipo == ITEM_TIPO_PRODUTO)
					produtos.push(item);
				else
					servicos.push(item);	
			});
		
			setListaOfertasProtutos(util.criarPares(produtos));
			setListaOfertasServicos(util.criarPares(servicos));
		}
		else{
			
			setListaOfertasProtutos([])
	
			setListaOfertasServicos([])
		}
		
		setSincronizandoOfertas(false)
	}
	

    return (
		<ViewDegradeVertical dadosBarra={getTopo()}>
			<Scroll>
				<View style={estilos.grade}>
					<View style={[estilos.coluna, {margin:2}]}>	
						<ItemCard 
							acao={()=>{
								
								util.setVoltar(null);

								navegacao.navigate(TELA_DETALHE_USUARIO)

							}}
							icon="usuario.png"
							titulo="Meus Dados"/>
					</View>
					<View style={[estilos.coluna, {margin:2}]}>	
						<ItemCard 
							acao={()=>{
								
								util.setVoltar(null);
								
								navegacao.navigate(TELA_MEUS_ITENS)
							
							}}
							icon="produtos_servicos.png"
							titulo="Produtos"/>
					</View>								
				</View>
				<View style={estilos.grade}>
					<View style={[estilos.coluna, {margin:2}]}>	
						<ItemCard 
							acao={()=>{
								
								util.setVoltar(null);

								navegacao.navigate(TELA_ANUNCIO)

							}}
							icon="loja.png"
							titulo="Minha Loja"/> 
					</View>
					<View style={[estilos.coluna, {margin:2}]}>	
						<ItemCard 
							acao={()=>{
								
								util.setVoltar(null);

								navegacao.navigate(TELA_MEUS_PEDIDOS)

							}}
							icon="pedido.png"
							titulo="Meus Pedidos"/>  
					</View>								
				</View>
				<View style={estilos.grade}>
					<View style={[estilos.coluna, {margin:2}]}>	
						<ItemCard 
							acao={()=>{
								
								util.setVoltar(null);

								navegacao.navigate(TELA_MINHAS_PROPOSTAS)
							}}
							icon="proposta.png"
							titulo="Minhas Propostas"/>
					</View>
					<View style={[estilos.coluna, {margin:2}]}>	
						<ItemCard 
							acao={()=>{
								
								util.setVoltar(null);
								
								navegacao.navigate(TELA_FINANCEIRA)

							}}	
							icon="financeiro.png"
							titulo={'Financeiro'}/>   
					</View>								
				</View>
				<View style={estilos.grade}>
					<View style={[estilos.coluna, {margin:2}]}>	
						<ItemCard 
							acao={()=>{
								
								util.setVoltar(null);

								navegacao.navigate(TELA_MEUS_ENDERECOS)
							}}
							icon="endereco.png"
							titulo="Endereços"/>
					</View>
					<View style={[estilos.coluna, {margin:2}]}>	
						<ItemCard 
							acao={()=>{
								
								util.setVoltar(null);

								navegacao.navigate(TELA_LOGIN)
							}}
							icon="sair.png"
							titulo="Sair"/>
					</View>
				</View>
			
				{listaPedidosDisponiveis()}
				
				{listaProdutosDisponiveis()}

				{listaServicosDisponiveis()}
				
				{(valorContexto.privilegio == PRIVILEGIO_GESTOR || valorContexto.privilegio == PRIVILEGIO_ADMIN) && 
					<View style={{marginTop: 10, marginBottom: 10}}> 
				
						<View style={{alignItems:'center'}}>
							<Text style={[estilos.rotulo_titulo, {color:cores.fonte_clara}]}>Recursos para Administradores</Text>	    
						</View>
				
						<View style={{marginTop:20}}/>
						
						<View style={estilos.grade}>
							<View style={[estilos.coluna, {margin:2}]}>	
								<ItemCard 
									acao={()=>{
										
										util.setVoltar(null);
										
										navegacao.navigate(TELA_CATEGORIA)
									
									}}
									icon="categoria.png"
									titulo="Categorias"/>
							</View>
							<View style={[estilos.coluna, {margin:2}]}>	
								
								<ItemCard 
									acao={()=>{
										
										util.setVoltar(null);

										navegacao.navigate(TELA_SUBCATEGORIA)
									
									}}
									icon="subcategoria.png"
									titulo="Subcategorias"/>
							</View>								
						</View>
						<View style={estilos.grade}>
							<View style={[estilos.coluna, {margin:2}]}>	
								<ItemCard 
									acao={()=>{
										
										util.setVoltar(null);

										navegacao.navigate(TELA_DENUNCIAS)
									
									}}
									icon="chat.png"
									titulo="Denuncias"/>
							</View>
							<View style={[estilos.coluna, {margin:2}]}>	
								
							</View>								
						</View>
					</View>	
				}
			</Scroll>
		</ViewDegradeVertical>); 
	
	
	function getTopo(){
	
		return (
            <View style={estilos.grade}>
				<View style={estilos.coluna_tripla}>
				<View style={{marginTop:6}}/>
					<Text style={[estilos.rotulo_titulo, {color: cores.fonte_clara}]}>{valorContexto.nomeUsuarioAtual}</Text>
				</View>
				<View style={{alignItems:'flex-end'}}>
					<View style={{marginTop:8}}/>  
					<Text style={[estilos.rotulo_titulo, {color: cores.fonte_clara}]}>{valorContexto.saldoAtual.toString()} pts</Text>
				</View>
			</View>)
	}
	
	
	function itemListaPedidos(item, index){

		return (
			<View key={index}> 
				<View style={{borderColor: cores.cinza_claro, borderWidth: 1, padding:5}}> 
					<View style={estilos.grade}>
						<View style={{marginRight:20}}>	
							<Imagem imagem={item.imagem} tamanho={80}/>
						</View>
						<View style={estilos.coluna}>
							<View style={{alignItems:'flex-end'}}> 
								<Text style={estilos.rotulo_menor}>Expira em: {data.converteDataEuaParaBr(item.data_expiracao)}</Text>
							</View>
							<Text style={estilos.rotulo_titulo}>{item.titulo}</Text>
							{util.temConteudo(item.descricao) && <Text style={estilos.rotulo_padrao}>{util.substring(item.descricao, 60)}</Text>}
						</View>
					</View>	
				
					<View style={{alignItems:'flex-end'}}> 
						<Botao 
							acao={()=>{
								
								console.log("verPedido id_pedido="+item.id);
			
								setValorContexto(prevState =>({...prevState, idPedido: item.id}));

								navegacao.navigate(TELA_DETALHE_PEDIDO)
								
							}}
							cor={cores.azul}
							texto="Detalhar"/>  
					</View>
				</View>
				<View style={{marginTop:10}}/>
			</View>	
		)
	}
	
	
	function parListaOferta(item, index){
		
		return (
			<View key={index} style={{flex:1}}> 
				<View style={[estilos.grade]}>
					<View style={[estilos.coluna, {marginRinght:10}]}>	
						<View style={{flex:1, margin:2, padding: 5, borderColor: cores.cinza_claro, borderWidth: 1}}>
							{itemListaOferta(item[0])}
						</View>
					</View>
					<View style={[estilos.coluna, {marginRinght:10}]}>	
						{item[1]!=null?
							<View style={{flex:1, margin:2, padding: 5, borderColor: cores.cinza_claro, borderWidth: 1}}>
								{itemListaOferta(item[1])}
							</View>:
							<View></View>
						}
					</View>
				</View>
			</View>
		)
	}
	
	
	function itemListaOferta(item){
		
		let infos = util.substring(util.outrasInfosItem(item), 100);
		
		return (
			<View style={{alignItems:'center', flex:1}}> 
				<Imagem imagem={item.imagem} tamanho={80}/>
				<View style={{marginTop:10}}/>
				<Text style={estilos.rotulo_padrao}>{util.substring(item.descricao, 100)}</Text>
				{util.temConteudo(infos) && <Text style={estilos.rotulo_menor}>{infos}</Text>}
				{util.temConteudo(item.valor) && <Text style={estilos.rotulo_titulo}>{'R$: '+numeros.formataNumeroParaMostrar(item.valor)}</Text>}
				<View style={{marginTop:10}}/>
				<Botao 
					acao={()=>{
						
						console.log("verItem "+item.id);
		
						setValorContexto(prevState =>({...prevState, idItem: item.id}));

						navegacao.navigate('detalheItem')
					}}
					texto="Detalhar"
					cor={cores.azul}/> 
				<View style={{marginTop:10}}/>		
			</View>
		)
	}
	
	
	function listaPedidosDisponiveis(){
		
		return (
			<Bloco todaArea={true}>  
				
				<View style={{alignItems:'center'}}>
					<Text style={estilos.rotulo_titulo}>Pedidos de Orçamento Disponíveis</Text>	    
				</View>
				
				<View style={{marginTop:20}}/>
				
				{(sincronizandoPedidos)?
					(<View>
						{carregamento(sincronizandoPedidos)}
					</View>):
					(util.temConteudo(listaPedidos))?
						(listaPedidos.map((item, index) => itemListaPedidos(item, index))):
						(<View>
							{semDados("sentiment-very-dissatisfied", "Não há novos pedidos no momento")}
						</View>)
				}

				<View style={{marginTop:10}}/>
				<View style={estilos.separador_cinza_claro}/> 
				<View style={{marginTop:10}}/>
				<View style={{alignItems:'center'}}>
					<Botao 
						acao={()=>navegacao.navigate(TELA_BUSCAR_PEDIDOS)}
						somente_texto={true}
						texto="Ver mais Pedidos"/> 
				</View>
				<View style={{marginTop:10}}/>
			</Bloco>	
		)
	}
	
	
	function listaProdutosDisponiveis(){
		
		return (
			
				<Bloco todaArea={true}>  
					
					<View style={{alignItems:'center'}}>
						<Text style={estilos.rotulo_titulo}>Produtos em Destaque</Text>	    
					</View>
					
					<View style={{marginTop:20}}/>
					
					{(sincronizandoOfertas)?
						(<View>
							{carregamento(sincronizandoOfertas)}
						</View>):
						(util.temConteudo(listaOfertasProtutos))?
							(listaOfertasProtutos.map((item, index) => parListaOferta(item, index))):
							(<View>
								{semDados("sentiment-very-dissatisfied", "Não há novos produtos em destaque")}
							</View>)
					}
					
					<View style={{marginTop:10}}/>
					<View style={estilos.separador_cinza_claro}/> 
					<View style={{marginTop:10}}/>
					<View style={{alignItems:'center'}}>
						<Botao 
							acao={()=>navegacao.navigate(TELA_BUSCAR_ITENS)}
							somente_texto={true}
							texto="Ver mais Produtos"/> 
					</View>
					<View style={{marginTop:10}}/>
					
				</Bloco>
				
			
		)
	}


	function listaServicosDisponiveis(){
		
		return (
			<Bloco todaArea={true}>  
					
					<View style={{alignItems:'center'}}>
						<Text style={estilos.rotulo_titulo}>Serviços em Destaque</Text>	    
					</View>
					
					<View style={{marginTop:20}}/>
					
					{(sincronizandoOfertas)?
						(<View>
							{carregamento(sincronizandoOfertas)}
						</View>):
						(util.temConteudo(listaOfertasServicos))?
							(listaOfertasServicos.map((item, index) => parListaOferta(item, index))):
							(<View>
								{semDados("sentiment-very-dissatisfied", "Não há novos serviços em destaque")}
							</View>)
					}
			
					<View style={{marginTop:10}}/>
					<View style={estilos.separador_cinza_claro}/> 
					<View style={{marginTop:10}}/>
					<View style={{alignItems:'center'}}>	
						<Botao 
							acao={()=>navegacao.navigate(TELA_BUSCAR_ITENS)}
							somente_texto={true}
							texto="Ver mais Serviços"/> 
					</View>
					<View style={{marginTop:10}}/>
				</Bloco>

		)
	}
}
